
// the player profile Alpine object
window.appSavePlayer = () => {
    return {
        status: 'default',
        init: function(id) {
            this.status = false;
            axios.get('/api/saved-player/' + id)
                .then( response => {
                    if( response.data == '1' ) {
                        this.status = 'saved';
                    } else {
                        this.status = 'default';
                    }
                })
                .catch( ajaxFail );
        },
        save: function(id) {
            if( this.status == 'saved') {
                return;
            }
            this.status = 'saving';
            axios.post('/api/save-player/' + id)
                .then( () => {
                    this.status = 'saved';
                    // setTimeout( () =>  this.status = 'default', 3000);

                    // initialise the save comparison component
                    window.dispatchEvent(new CustomEvent('refresh-saved-players'));
                })
                .catch( ajaxFail );
        }
    }
}
